const SMALL = `${process.env.PUBLIC_URL}/logo-mark-192.png`;
const LARGE = `${process.env.PUBLIC_URL}/logo-mark-512.png`;

export const Logo = ({ size = 96, className = "", decorative = false }) => (
    <img
        src={size <= 200 ? SMALL : LARGE}
        width={size}
        height={size}
        style={{ width: size, height: size }}
        className={className}
        alt={decorative ? "" : "deep end grooves — overlapping terracotta, aubergine and amber circles"}
        aria-hidden={decorative ? "true" : undefined}
    />
);
